/* eslint-disable func-names */
import React, { FunctionComponent } from 'react'
import { LoadingOutlined } from '@ant-design/icons'

import { colors } from 'Styled/variables'

import { LoadingSpinnerProps } from './props'
import { Spinner } from './styles'

export const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = ({
  color = colors.white,
  size = 'default',
}) => <Spinner size={size} indicator={<LoadingOutlined style={{ color }} />} />
